<template>
    <Main>
        <box-loading v-if="isLoading"></box-loading>
        <div v-else class="px-0 px-sm-3">
            <InputField classes="mb-2 mb-sm-3" is-required :label-text="$t('sendMail.name')">
                <InputText v-model="mail.name" @keydown.native="onHandle('name', 'validate')"></InputText>
                <template #error v-if="errorInfo.name">{{ errorInfo.name }}</template>
            </InputField>
            <InputField classes="mb-2 mb-sm-3" :label-text="$t('sendMail.title')">
                <InputText v-model="mail.title" @keydown.native="onHandle('title', 'validate')"></InputText>
                <template #error v-if="errorInfo.title">{{ errorInfo.title }}</template>
            </InputField>
            <InputField classes="mb-2 mb-sm-3" :label-text="$t('sendMail.content')">
                <vue-editor v-model="mail.content" class="custom-mail-invite"></vue-editor>
            </InputField>
        </div>
        <template #bottomAction>
            <div class="text-right pr-sm-3 pr-0">
                <Button type="warning" classes="mr-2" @click="$router.push('/mail-invite')">{{ $t('button.cancel') }}</Button>
                <Button v-if="!isUpdate" type="primary" v-loading="isLoading" @click="create">{{ $t('button.register') }}</Button>
                <Button v-if="isUpdate" type="primary" v-loading="isLoading" @click="update">{{ $t('button.save') }}</Button>
            </div>
        </template>
    </Main>
</template>

<script>
import { onValidate, validateAllField, getObjectData } from './index.js';
import Main from '@/components/partials/layout/Main';
import { VueEditor } from 'vue2-editor';
import InputField from '@/components/partials/InputField';
import InputText from '@/components/partials/customs/InputText';
import Button from '@/components/partials/Button';
import BoxLoading from '@/components/partials/BoxLoading';
export default {
    components: {
        BoxLoading,
        Button,
        InputText,
        Main,
        VueEditor,
        InputField
    },
    data() {
        return {
            isLoading: false,
            isUpdate: false,
            mail: {
                name: '',
                title: '【DBHUB】ご利用招待メール',
                content: ''
            },
            errorInfo: {
                name: '',
                title: '',
                content: ''
            }
        };
    },
    computed: {},
    mounted() {
        if (this.$route.query.id) {
            this.isUpdate = true;
            this.getDetail();
        }
    },
    methods: {
        getDetail() {
            this.isLoading = true;
            let successCallback = (response) => {
                let data = response.data.data.data;
                this.mail.name = data.name;
                this.mail.title = data.title;
                this.mail.content = data.content_add;
                this.isLoading = false;
            };
            let errorCallback = () => {
                this.isLoading = false;
            };
            let payload = {
                id: this.$route.query.id,
                successCallback,
                errorCallback
            };
            this.$store.dispatch('mail/detail', payload);
        },
        create() {
            const payload = {
                data: getObjectData(this.mail)
            };
            this.handleSave('text.resignSuccess', '/mail-invite', 'mail/create', payload);
        },
        update() {
            const payload = {
                id: this.$route.query.id,
                data: getObjectData(this.mail)
            };
            this.handleSave('text.saveSuccess', '/mail-invite', 'mail/update', payload);
        },
        handleSave(successMessage, redirectPath, action, additionalPayload = {}) {
            if (this.isLoading || !validateAllField(this.mail, this.errorInfo)) return;

            this.isLoading = true;

            const successCallback = () => {
                this.$store.commit('noticeSystem/SET_MESSAGE', {
                    isShowMessage: true,
                    type: 'success',
                    message: this.$t(successMessage)
                });
                this.isLoading = false;
                this.$router.push({ path: redirectPath });
            };

            const errorCallback = () => {
                this.isLoading = false;
            };

            const payload = {
                ...additionalPayload,
                successCallback,
                errorCallback
            };

            this.$store.dispatch(action, payload);
        },
        onHandle(field, process) {
            if (process.includes('validate')) {
                onValidate(field, this.mail, this.errorInfo);
            }
        }
    }
};
</script>
